import { TagActionEnum, TagEntityTypeEnum } from './manage-tags-modal.constant';

export class ManageTagRange {
  tagsId: string[];
  entitiesOrIndividualsId: string[];
  tagAction: TagActionEnum;
  type: TagEntityTypeEnum;

  constructor(data: Partial<ManageTagRange> = {}) {
    this.tagsId = data.tagsId ?? [];
    this.entitiesOrIndividualsId = data.entitiesOrIndividualsId ?? [];
    this.tagAction = data.tagAction ?? TagActionEnum.Assign;
    this.type = data.type ?? TagEntityTypeEnum.Company;
  }
}
